// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-eval-capture__hidden-video {
  /* Keep a small in-viewport decoder so Chrome/Safari do not freeze the
     camera. Off-screen / opacity:0 elements throttle capture and produced
     empty eval clips that never reached the server. */
  position: fixed;
  right: 8px;
  bottom: 8px;
  width: 48px;
  height: 27px;
  opacity: 0.04;
  pointer-events: none;
  z-index: 1;
  object-fit: cover;
}

.lt-eval-capture__hidden-canvas {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 9px;
  opacity: 0.02;
  pointer-events: none;
  z-index: 0;
}

.lt-eval-mic-warning {
  position: fixed;
  top: calc(8px + env(safe-area-inset-top));
  left: 50%;
  transform: translateX(-50%);
  width: min(92vw, 520px);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #7f1d1d;
  color: #fef2f2;
  font-size: 13px;
  line-height: 1.35;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  /* Above the calibration overlay so it stays visible while framing the table. */
  z-index: 14010;
}

.lt-eval-mic-warning__text {
  flex: 1 1;
  min-width: 0;
}

.lt-eval-mic-warning__btn {
  flex-shrink: 0;
  border: 1px solid rgba(254, 242, 242, 0.6);
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 600;
  padding: 6px 10px;
  cursor: pointer;
}

/* ------------------------------------------------------------------
   Camera calibration HUD — viewfinder chrome.
   Preview is full-bleed; controls hug the borders as glass icon rails.
   ------------------------------------------------------------------ */
.lt-eval-calib {
  --calib-ink: #f8fafc;
  --calib-muted: rgba(248, 250, 252, 0.78);
  --calib-glass: rgba(6, 12, 24, 0.28);
  --calib-glass-hot: rgba(6, 12, 24, 0.48);
  --calib-label-bg: rgba(6, 12, 24, 0.55);
  --calib-border: rgba(255, 255, 255, 0.14);
  --calib-active: color-mix(in srgb, var(--lt-brand, #0877bc) 78%, transparent);
  --calib-accent: #38bdf8;
  --calib-lens: #facc15;
  --calib-tap: 40px;

  /* Fill the live page. Absolute (not fixed) so iPhone visual viewport
     and .lt-page container-type sizing do not double-offset the chrome. */
  position: absolute;
  inset: 0;
  z-index: 14000;
  background: transparent;
  color: var(--calib-ink);
  overflow: hidden;
  box-sizing: border-box;
  container-type: size;
  container-name: lt-eval-calib;
  font-family: "Segoe UI", "Helvetica Neue", system-ui, sans-serif;
}

.lt-eval-calib__stage {
  position: absolute;
  inset: 0;
  background: #020617;
  overflow: hidden;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
}

.lt-eval-calib__stage--switching .lt-eval-calib__preview {
  opacity: 0.88;
  transition: opacity 0.18s ease;
}

.lt-eval-calib__preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #020617;
  transform-origin: center center;
  will-change: transform;
  transition: opacity 0.18s ease;
}

/* Chrono list must not eat the framing area while calibrating. */
.lt-eval-calib__stage .lt-chrono-cam {
  left: calc(56px + env(safe-area-inset-left, 0px));
  right: calc(56px + env(safe-area-inset-right, 0px));
  bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  width: auto;
  max-height: 22%;
  padding: 4px 6px;
  background: rgba(6, 12, 24, 0.38);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Empty space must pass pinch through to the stage. */
.lt-eval-calib__top,
.lt-eval-calib__hint,
.lt-eval-calib__chrome,
.lt-eval-calib__edge,
.lt-eval-calib__rail,
.lt-eval-calib__zoom-pill,
.lt-eval-calib__rec-pill {
  pointer-events: none;
}

.lt-eval-calib__top button,
.lt-eval-calib__edge button,
.lt-eval-calib__edge .lt-eval-calib__chip,
.lt-eval-calib__edge .lt-eval-calib__lens,
.lt-eval-calib__edge .lt-eval-calib__zoom-reset {
  pointer-events: auto;
}

/* ---- Top: floating title / close pills (no full-width scrim) ---- */
.lt-eval-calib__top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding:
    calc(8px + env(safe-area-inset-top, 0px))
    calc(8px + env(safe-area-inset-right, 0px))
    0
    calc(8px + env(safe-area-inset-left, 0px));
  background: none;
}

.lt-eval-calib__title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: calc(100% - 52px);
  padding: 6px 10px 6px 8px;
  border-radius: 999px;
  border: 1px solid var(--calib-border);
  background: var(--calib-label-bg);
  backdrop-filter: blur(16px) saturate(1.2);
  -webkit-backdrop-filter: blur(16px) saturate(1.2);
  color: var(--calib-ink);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);
}

.lt-eval-calib__title-row .MuiSvgIcon-root {
  flex: 0 0 auto;
  opacity: 0.9;
  font-size: 18px !important;
}

.lt-eval-calib__title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-eval-calib__meta-chip {
  flex: 0 0 auto;
  padding: 2px 7px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.08);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  font-variant-numeric: tabular-nums;
  color: var(--calib-muted);
}

.lt-eval-calib__hint {
  position: absolute;
  left: 50%;
  bottom: calc(14px + env(safe-area-inset-bottom, 0px));
  z-index: 2;
  width: max-content;
  max-width: min(70vw, 360px);
  margin: 0;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid var(--calib-border);
  background: var(--calib-label-bg);
  backdrop-filter: blur(14px) saturate(1.15);
  -webkit-backdrop-filter: blur(14px) saturate(1.15);
  transform: translateX(-50%);
  font-size: 11px;
  line-height: 1.35;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: var(--calib-muted);
  text-align: center;
  text-shadow: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.lt-eval-calib__hint:empty {
  display: none;
}

/* ---- Edge chrome ---- */
.lt-eval-calib__chrome {
  position: absolute;
  inset: 0;
  z-index: 2;
}

.lt-eval-calib__edge {
  position: absolute;
  z-index: 2;
  display: flex;
  gap: 10px;
}

.lt-eval-calib__edge--left {
  top: calc(56px + env(safe-area-inset-top, 0px));
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  left: calc(6px + env(safe-area-inset-left, 0px));
  width: max-content;
  max-width: 28%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}

.lt-eval-calib__edge--right {
  top: calc(56px + env(safe-area-inset-top, 0px));
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  right: calc(6px + env(safe-area-inset-right, 0px));
  width: max-content;
  max-width: 28%;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}

/* Bottom tab bar removed — capture settings live on the side rails. */
.lt-eval-calib__edge--bottom {
  display: none;
}

/* Rail = labeled icon cluster */
.lt-eval-calib__rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
}

.lt-eval-calib__edge--left .lt-eval-calib__rail,
.lt-eval-calib__edge--right .lt-eval-calib__rail {
  align-items: stretch;
}

.lt-eval-calib__edge--right .lt-eval-calib__rail {
  align-items: flex-end;
}

.lt-eval-calib__edge--left .lt-eval-calib__rail {
  align-items: flex-start;
}

.lt-eval-calib__rail-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: var(--calib-label-bg);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--calib-muted);
  line-height: 1.4;
  white-space: nowrap;
}

.lt-eval-calib__dock-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  padding: 4px;
  border-radius: 18px;
  border: 1px solid var(--calib-border);
  background: var(--calib-glass);
  backdrop-filter: blur(16px) saturate(1.2);
  -webkit-backdrop-filter: blur(16px) saturate(1.2);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
}

.lt-eval-calib__edge--left .lt-eval-calib__dock-row--zoom,
.lt-eval-calib__edge--left .lt-eval-calib__dock-row,
.lt-eval-calib__edge--left .lt-eval-calib__dock-row--stack,
.lt-eval-calib__edge--right .lt-eval-calib__dock-row--lenses,
.lt-eval-calib__edge--right .lt-eval-calib__dock-row,
.lt-eval-calib__edge--right .lt-eval-calib__dock-row--stack {
  flex-direction: column;
}

.lt-eval-calib__zoom-reset {
  min-width: var(--calib-tap);
  height: 32px;
  padding: 0 8px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: transparent;
  color: var(--calib-ink);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
}

.lt-eval-calib__chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  min-height: var(--calib-tap);
  min-width: var(--calib-tap);
  padding: 0 6px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: transparent;
  color: rgba(248, 250, 252, 0.9);
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.lt-eval-calib__chip--mark {
  min-width: var(--calib-tap);
  padding: 0;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.lt-eval-calib__chip.is-on,
.lt-eval-calib__icon-btn--active {
  background: var(--calib-active);
  border-color: rgba(255, 255, 255, 0.22);
  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.22);
  color: #fff;
}

.lt-eval-calib__chip:disabled,
.lt-eval-calib__icon-btn:disabled,
.lt-eval-calib__lens:disabled {
  opacity: 0.38;
  cursor: not-allowed;
}

.lt-eval-calib__chip:hover:not(:disabled),
.lt-eval-calib__icon-btn:hover:not(:disabled),
.lt-eval-calib__lens:hover:not(:disabled),
.lt-eval-calib__zoom-reset:hover:not(:disabled) {
  transform: scale(1.05);
  background: var(--calib-glass-hot);
}

.lt-eval-calib__chip:active:not(:disabled),
.lt-eval-calib__icon-btn:active:not(:disabled),
.lt-eval-calib__lens:active:not(:disabled) {
  transform: scale(0.95);
}

.lt-eval-calib__lens {
  width: var(--calib-tap);
  height: var(--calib-tap);
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 50%;
  background: var(--calib-glass);
  color: rgba(248, 250, 252, 0.92);
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

.lt-eval-calib__lens-mark {
  display: grid;
  place-items: center;
  line-height: 1;
}

/* Lens name is visually hidden; kept for a11y / screen readers via aria. */
.lt-eval-calib__lens-name {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.lt-eval-calib__lens--wide {
  border-radius: 14px;
}

.lt-eval-calib__dock-row--lenses-wide {
  gap: 6px;
}

.lt-eval-calib__lens.is-on {
  color: var(--calib-lens);
  border-color: var(--calib-lens);
  background: rgba(6, 12, 24, 0.62);
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.32);
}

.lt-eval-calib__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--calib-tap);
  height: var(--calib-tap);
  border: 1px solid transparent;
  border-radius: 14px;
  background: transparent;
  color: var(--calib-ink);
  cursor: pointer;
  transition:
    transform 0.15s ease,
    background 0.15s ease,
    border-color 0.15s ease;
}

.lt-eval-calib__top .lt-eval-calib__icon-btn {
  border-color: var(--calib-border);
  background: var(--calib-label-bg);
  backdrop-filter: blur(16px) saturate(1.2);
  -webkit-backdrop-filter: blur(16px) saturate(1.2);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);
}

.lt-eval-calib__icon-btn:focus-visible,
.lt-eval-calib__chip:focus-visible,
.lt-eval-calib__lens:focus-visible,
.lt-eval-calib__zoom-reset:focus-visible {
  outline: 2px solid var(--calib-accent);
  outline-offset: 2px;
}

.lt-eval-calib__zoom-pill {
  position: absolute;
  top: calc(58px + env(safe-area-inset-top, 0px));
  right: calc(58px + env(safe-area-inset-right, 0px));
  z-index: 2;
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--calib-label-bg);
  border: 1px solid var(--calib-border);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  font-variant-numeric: tabular-nums;
  color: var(--calib-ink);
}

.lt-eval-calib__rec-pill {
  position: absolute;
  top: calc(58px + env(safe-area-inset-top, 0px));
  left: calc(58px + env(safe-area-inset-left, 0px));
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(127, 29, 29, 0.62);
  border: 1px solid rgba(248, 113, 113, 0.45);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.lt-eval-calib__rec-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fecaca;
  box-shadow: 0 0 8px #ef4444;
  animation: lt-eval-rec-pulse 1.1s ease-in-out infinite;
}

@keyframes lt-eval-rec-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
}

/* Table coverage strip */
.lt-eval-calib__tables {
  position: absolute;
  top: calc(52px + env(safe-area-inset-top, 0px));
  left: calc(10px + env(safe-area-inset-left, 0px));
  right: calc(10px + env(safe-area-inset-right, 0px));
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  pointer-events: none;
}

.lt-eval-calib__dock-row--tables {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  pointer-events: auto;
  touch-action: pan-x;
}

.lt-eval-calib__dock-row--tables::-webkit-scrollbar {
  display: none;
}

.lt-eval-calib__tables-label {
  flex: 0 0 auto;
  padding: 2px 8px;
  margin-right: 2px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: var(--calib-label-bg);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--calib-muted);
}

.lt-eval-calib__table {
  position: relative;
  flex: 0 0 auto;
  min-width: 36px;
  padding: 0 8px;
  font-size: 13px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.lt-eval-calib__table:not(.is-on) {
  color: rgba(248, 250, 252, 0.62);
  border-style: dashed;
  border-color: rgba(255, 255, 255, 0.18);
}

.lt-eval-calib__table.is-main {
  border-color: var(--calib-lens);
  box-shadow: 0 0 0 1px rgba(250, 204, 21, 0.4);
}

.lt-eval-calib__table-star {
  position: absolute;
  top: 3px;
  right: 3px;
  color: var(--calib-lens);
  fill: var(--calib-lens);
}

.lt-eval-calib__tables-all {
  flex: 0 0 auto;
  margin-left: 2px;
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.lt-eval-calib__tables-caption {
  margin: 0;
  max-width: min(92vw, 360px);
  padding: 3px 10px;
  border-radius: 999px;
  background: var(--calib-label-bg);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  font-size: 10px;
  line-height: 1.3;
  text-align: center;
  color: var(--calib-muted);
  text-shadow: none;
}

/* Portrait: side docks start below the strip */
.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--left,
.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--right {
  top: calc(118px + env(safe-area-inset-top, 0px));
}

.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__zoom-pill,
.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__rec-pill {
  top: calc(120px + env(safe-area-inset-top, 0px));
}

.lt-eval-calib--landscape .lt-eval-calib__tables {
  left: calc(64px + env(safe-area-inset-left, 0px));
  right: calc(64px + env(safe-area-inset-right, 0px));
}

.lt-eval-calib--landscape.lt-eval-calib--tables .lt-eval-calib__zoom-pill,
.lt-eval-calib--landscape.lt-eval-calib--tables .lt-eval-calib__rec-pill {
  top: calc(112px + env(safe-area-inset-top, 0px));
}

.lt-eval-calib--landscape .lt-eval-calib__hint {
  left: 50%;
  right: auto;
  bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  max-width: min(60vw, 420px);
}

.lt-eval-calib--landscape .lt-eval-calib__edge--left {
  top: calc(52px + env(safe-area-inset-top, 0px));
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  left: calc(6px + env(safe-area-inset-left, 0px));
}

.lt-eval-calib--landscape .lt-eval-calib__edge--right {
  top: calc(52px + env(safe-area-inset-top, 0px));
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  right: calc(6px + env(safe-area-inset-right, 0px));
}

.lt-eval-calib--landscape .lt-eval-calib__chip {
  min-width: 34px;
  padding: 0 4px;
}

.lt-page__fab--eval {
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.lt-page__fab--eval-off {
  background: rgba(71, 85, 105, 0.55);
  border-color: rgba(148, 163, 184, 0.35);
  opacity: 0.9;
}

.lt-page__fab--eval-live {
  background: #b91c1c;
  border-color: rgba(254, 202, 202, 0.55);
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.28),
    0 8px 22px rgba(185, 28, 28, 0.4);
}

.lt-page__fab--eval-live .lt-eval-fab-dot {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fecaca;
  animation: lt-eval-rec-pulse 1.1s ease-in-out infinite;
}

@media (max-width: 420px) {
  .lt-eval-calib {
    --calib-tap: 38px;
  }

  .lt-eval-calib__title {
    max-width: 36vw;
  }

  .lt-eval-calib__hint {
    bottom: calc(12px + env(safe-area-inset-bottom, 0px));
    font-size: 10px;
    max-width: min(68vw, 280px);
  }

  .lt-eval-calib__dock-row {
    gap: 2px;
    padding: 3px;
  }
}

@container lt-eval-calib (max-height: 560px) {
  .lt-eval-calib__edge--left,
  .lt-eval-calib__edge--right {
    top: calc(44px + env(safe-area-inset-top, 0px));
    bottom: calc(58px + env(safe-area-inset-bottom, 0px));
    gap: 6px;
  }

  .lt-eval-calib {
    --calib-tap: 36px;
  }

  .lt-eval-calib__zoom-pill,
  .lt-eval-calib__rec-pill {
    top: calc(48px + env(safe-area-inset-top, 0px));
  }

  .lt-eval-calib__tables {
    top: calc(44px + env(safe-area-inset-top, 0px));
  }

  .lt-eval-calib__tables-caption {
    display: none;
  }

  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--left,
  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--right {
    top: calc(90px + env(safe-area-inset-top, 0px));
  }

  .lt-eval-calib--tables .lt-eval-calib__zoom-pill,
  .lt-eval-calib--tables .lt-eval-calib__rec-pill,
  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__zoom-pill,
  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__rec-pill {
    top: calc(92px + env(safe-area-inset-top, 0px));
  }

  .lt-eval-calib__hint {
    bottom: calc(10px + env(safe-area-inset-bottom, 0px));
  }
}

@container lt-eval-calib (max-height: 420px) {
  .lt-eval-calib__edge--left,
  .lt-eval-calib__edge--right {
    top: calc(40px + env(safe-area-inset-top, 0px));
    bottom: calc(48px + env(safe-area-inset-bottom, 0px));
    justify-content: flex-start;
    gap: 4px;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-width: none;
  }

  .lt-eval-calib__edge--left::-webkit-scrollbar,
  .lt-eval-calib__edge--right::-webkit-scrollbar {
    display: none;
  }

  .lt-eval-calib__hint {
    display: none;
  }

  .lt-eval-calib__rail-label {
    display: none;
  }

  .lt-eval-calib__tables {
    top: calc(40px + env(safe-area-inset-top, 0px));
  }

  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--left,
  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--right {
    top: calc(84px + env(safe-area-inset-top, 0px));
  }
}

@media (prefers-reduced-motion: reduce) {
  .lt-eval-calib__chip,
  .lt-eval-calib__icon-btn,
  .lt-eval-calib__lens,
  .lt-eval-calib__preview,
  .lt-eval-calib__rec-dot,
  .lt-page__fab--eval-live .lt-eval-fab-dot {
    transition: none;
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingVideoCalibrationOverlay.css"],"names":[],"mappings":"AAAA;EACE;;sDAEoD;EACpD,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,+EAA+E;EAC/E,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;uEAGuE;AACvE;EACE,oBAAoB;EACpB,wCAAwC;EACxC,oCAAoC;EACpC,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,6EAA6E;EAC7E,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;;EAEjB;0EACwE;EACxE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,iEAAiE;AACjE;EACE,iDAAiD;EACjD,mDAAmD;EACnD,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA,sDAAsD;AACtD;;;;;;;EAOE,oBAAoB;AACtB;;AAEA;;;;;EAKE,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT;;;;8CAI4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,yCAAyC;EACzC,iDAAiD;EACjD,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qDAAqD;EACrD,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,0CAA0C;EAC1C,kDAAkD;EAClD,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;EACpD,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;EACpD,kDAAkD;EAClD,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,sEAAsE;AACtE;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,8BAA8B;EAC9B,yCAAyC;EACzC,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,4BAA4B;EAC5B,2BAA2B;EAC3B,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf;;;;oBAIkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;EAC/B,uCAAuC;EACvC,8CAA8C;EAC9C,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;;;yBAKuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf;;;2BAGyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,yCAAyC;EACzC,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;;;EAIE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mDAAmD;EACnD,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,iDAAiD;EACjD,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,iDAAiD;EACjD,mDAAmD;EACnD,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;EACpD,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;EAC/C,oDAAoD;EACpD,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC;qCACmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qDAAqD;IACrD,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,+CAA+C;IAC/C,qDAAqD;IACrD,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,+CAA+C;EACjD;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,+CAA+C;EACjD;;EAEA;;;;IAIE,+CAA+C;EACjD;;EAEA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE;;IAEE,+CAA+C;IAC/C,qDAAqD;IACrD,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,+CAA+C;EACjD;;EAEA;;IAEE,+CAA+C;EACjD;AACF;;AAEA;EACE;;;;;;IAME,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":[".lt-eval-capture__hidden-video {\n  /* Keep a small in-viewport decoder so Chrome/Safari do not freeze the\n     camera. Off-screen / opacity:0 elements throttle capture and produced\n     empty eval clips that never reached the server. */\n  position: fixed;\n  right: 8px;\n  bottom: 8px;\n  width: 48px;\n  height: 27px;\n  opacity: 0.04;\n  pointer-events: none;\n  z-index: 1;\n  object-fit: cover;\n}\n\n.lt-eval-capture__hidden-canvas {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  width: 16px;\n  height: 9px;\n  opacity: 0.02;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.lt-eval-mic-warning {\n  position: fixed;\n  top: calc(8px + env(safe-area-inset-top));\n  left: 50%;\n  transform: translateX(-50%);\n  width: min(92vw, 520px);\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: #7f1d1d;\n  color: #fef2f2;\n  font-size: 13px;\n  line-height: 1.35;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);\n  /* Above the calibration overlay so it stays visible while framing the table. */\n  z-index: 14010;\n}\n\n.lt-eval-mic-warning__text {\n  flex: 1;\n  min-width: 0;\n}\n\n.lt-eval-mic-warning__btn {\n  flex-shrink: 0;\n  border: 1px solid rgba(254, 242, 242, 0.6);\n  border-radius: 8px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: 600;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n/* ------------------------------------------------------------------\n   Camera calibration HUD — viewfinder chrome.\n   Preview is full-bleed; controls hug the borders as glass icon rails.\n   ------------------------------------------------------------------ */\n.lt-eval-calib {\n  --calib-ink: #f8fafc;\n  --calib-muted: rgba(248, 250, 252, 0.78);\n  --calib-glass: rgba(6, 12, 24, 0.28);\n  --calib-glass-hot: rgba(6, 12, 24, 0.48);\n  --calib-label-bg: rgba(6, 12, 24, 0.55);\n  --calib-border: rgba(255, 255, 255, 0.14);\n  --calib-active: color-mix(in srgb, var(--lt-brand, #0877bc) 78%, transparent);\n  --calib-accent: #38bdf8;\n  --calib-lens: #facc15;\n  --calib-tap: 40px;\n\n  /* Fill the live page. Absolute (not fixed) so iPhone visual viewport\n     and .lt-page container-type sizing do not double-offset the chrome. */\n  position: absolute;\n  inset: 0;\n  z-index: 14000;\n  background: transparent;\n  color: var(--calib-ink);\n  overflow: hidden;\n  box-sizing: border-box;\n  container-type: size;\n  container-name: lt-eval-calib;\n  font-family: \"Segoe UI\", \"Helvetica Neue\", system-ui, sans-serif;\n}\n\n.lt-eval-calib__stage {\n  position: absolute;\n  inset: 0;\n  background: #020617;\n  overflow: hidden;\n  touch-action: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.lt-eval-calib__stage--switching .lt-eval-calib__preview {\n  opacity: 0.88;\n  transition: opacity 0.18s ease;\n}\n\n.lt-eval-calib__preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #020617;\n  transform-origin: center center;\n  will-change: transform;\n  transition: opacity 0.18s ease;\n}\n\n/* Chrono list must not eat the framing area while calibrating. */\n.lt-eval-calib__stage .lt-chrono-cam {\n  left: calc(56px + env(safe-area-inset-left, 0px));\n  right: calc(56px + env(safe-area-inset-right, 0px));\n  bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  width: auto;\n  max-height: 22%;\n  padding: 4px 6px;\n  background: rgba(6, 12, 24, 0.38);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Empty space must pass pinch through to the stage. */\n.lt-eval-calib__top,\n.lt-eval-calib__hint,\n.lt-eval-calib__chrome,\n.lt-eval-calib__edge,\n.lt-eval-calib__rail,\n.lt-eval-calib__zoom-pill,\n.lt-eval-calib__rec-pill {\n  pointer-events: none;\n}\n\n.lt-eval-calib__top button,\n.lt-eval-calib__edge button,\n.lt-eval-calib__edge .lt-eval-calib__chip,\n.lt-eval-calib__edge .lt-eval-calib__lens,\n.lt-eval-calib__edge .lt-eval-calib__zoom-reset {\n  pointer-events: auto;\n}\n\n/* ---- Top: floating title / close pills (no full-width scrim) ---- */\n.lt-eval-calib__top {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding:\n    calc(8px + env(safe-area-inset-top, 0px))\n    calc(8px + env(safe-area-inset-right, 0px))\n    0\n    calc(8px + env(safe-area-inset-left, 0px));\n  background: none;\n}\n\n.lt-eval-calib__title-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  max-width: calc(100% - 52px);\n  padding: 6px 10px 6px 8px;\n  border-radius: 999px;\n  border: 1px solid var(--calib-border);\n  background: var(--calib-label-bg);\n  backdrop-filter: blur(16px) saturate(1.2);\n  -webkit-backdrop-filter: blur(16px) saturate(1.2);\n  color: var(--calib-ink);\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);\n}\n\n.lt-eval-calib__title-row .MuiSvgIcon-root {\n  flex: 0 0 auto;\n  opacity: 0.9;\n  font-size: 18px !important;\n}\n\n.lt-eval-calib__title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-eval-calib__meta-chip {\n  flex: 0 0 auto;\n  padding: 2px 7px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.08);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  font-variant-numeric: tabular-nums;\n  color: var(--calib-muted);\n}\n\n.lt-eval-calib__hint {\n  position: absolute;\n  left: 50%;\n  bottom: calc(14px + env(safe-area-inset-bottom, 0px));\n  z-index: 2;\n  width: max-content;\n  max-width: min(70vw, 360px);\n  margin: 0;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid var(--calib-border);\n  background: var(--calib-label-bg);\n  backdrop-filter: blur(14px) saturate(1.15);\n  -webkit-backdrop-filter: blur(14px) saturate(1.15);\n  transform: translateX(-50%);\n  font-size: 11px;\n  line-height: 1.35;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: var(--calib-muted);\n  text-align: center;\n  text-shadow: none;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n}\n\n.lt-eval-calib__hint:empty {\n  display: none;\n}\n\n/* ---- Edge chrome ---- */\n.lt-eval-calib__chrome {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n}\n\n.lt-eval-calib__edge {\n  position: absolute;\n  z-index: 2;\n  display: flex;\n  gap: 10px;\n}\n\n.lt-eval-calib__edge--left {\n  top: calc(56px + env(safe-area-inset-top, 0px));\n  bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  left: calc(6px + env(safe-area-inset-left, 0px));\n  width: max-content;\n  max-width: 28%;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.lt-eval-calib__edge--right {\n  top: calc(56px + env(safe-area-inset-top, 0px));\n  bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  right: calc(6px + env(safe-area-inset-right, 0px));\n  width: max-content;\n  max-width: 28%;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n/* Bottom tab bar removed — capture settings live on the side rails. */\n.lt-eval-calib__edge--bottom {\n  display: none;\n}\n\n/* Rail = labeled icon cluster */\n.lt-eval-calib__rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  flex: 0 0 auto;\n}\n\n.lt-eval-calib__edge--left .lt-eval-calib__rail,\n.lt-eval-calib__edge--right .lt-eval-calib__rail {\n  align-items: stretch;\n}\n\n.lt-eval-calib__edge--right .lt-eval-calib__rail {\n  align-items: flex-end;\n}\n\n.lt-eval-calib__edge--left .lt-eval-calib__rail {\n  align-items: flex-start;\n}\n\n.lt-eval-calib__rail-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: var(--calib-label-bg);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--calib-muted);\n  line-height: 1.4;\n  white-space: nowrap;\n}\n\n.lt-eval-calib__dock-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex: 0 0 auto;\n  padding: 4px;\n  border-radius: 18px;\n  border: 1px solid var(--calib-border);\n  background: var(--calib-glass);\n  backdrop-filter: blur(16px) saturate(1.2);\n  -webkit-backdrop-filter: blur(16px) saturate(1.2);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);\n}\n\n.lt-eval-calib__edge--left .lt-eval-calib__dock-row--zoom,\n.lt-eval-calib__edge--left .lt-eval-calib__dock-row,\n.lt-eval-calib__edge--left .lt-eval-calib__dock-row--stack,\n.lt-eval-calib__edge--right .lt-eval-calib__dock-row--lenses,\n.lt-eval-calib__edge--right .lt-eval-calib__dock-row,\n.lt-eval-calib__edge--right .lt-eval-calib__dock-row--stack {\n  flex-direction: column;\n}\n\n.lt-eval-calib__zoom-reset {\n  min-width: var(--calib-tap);\n  height: 32px;\n  padding: 0 8px;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--calib-ink);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n}\n\n.lt-eval-calib__chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  min-height: var(--calib-tap);\n  min-width: var(--calib-tap);\n  padding: 0 6px;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: transparent;\n  color: rgba(248, 250, 252, 0.9);\n  font-size: 12px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.lt-eval-calib__chip--mark {\n  min-width: var(--calib-tap);\n  padding: 0;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.lt-eval-calib__chip.is-on,\n.lt-eval-calib__icon-btn--active {\n  background: var(--calib-active);\n  border-color: rgba(255, 255, 255, 0.22);\n  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.22);\n  color: #fff;\n}\n\n.lt-eval-calib__chip:disabled,\n.lt-eval-calib__icon-btn:disabled,\n.lt-eval-calib__lens:disabled {\n  opacity: 0.38;\n  cursor: not-allowed;\n}\n\n.lt-eval-calib__chip:hover:not(:disabled),\n.lt-eval-calib__icon-btn:hover:not(:disabled),\n.lt-eval-calib__lens:hover:not(:disabled),\n.lt-eval-calib__zoom-reset:hover:not(:disabled) {\n  transform: scale(1.05);\n  background: var(--calib-glass-hot);\n}\n\n.lt-eval-calib__chip:active:not(:disabled),\n.lt-eval-calib__icon-btn:active:not(:disabled),\n.lt-eval-calib__lens:active:not(:disabled) {\n  transform: scale(0.95);\n}\n\n.lt-eval-calib__lens {\n  width: var(--calib-tap);\n  height: var(--calib-tap);\n  flex: 0 0 auto;\n  display: grid;\n  place-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 50%;\n  background: var(--calib-glass);\n  color: rgba(248, 250, 252, 0.92);\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.lt-eval-calib__lens-mark {\n  display: grid;\n  place-items: center;\n  line-height: 1;\n}\n\n/* Lens name is visually hidden; kept for a11y / screen readers via aria. */\n.lt-eval-calib__lens-name {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.lt-eval-calib__lens--wide {\n  border-radius: 14px;\n}\n\n.lt-eval-calib__dock-row--lenses-wide {\n  gap: 6px;\n}\n\n.lt-eval-calib__lens.is-on {\n  color: var(--calib-lens);\n  border-color: var(--calib-lens);\n  background: rgba(6, 12, 24, 0.62);\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.32);\n}\n\n.lt-eval-calib__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--calib-tap);\n  height: var(--calib-tap);\n  border: 1px solid transparent;\n  border-radius: 14px;\n  background: transparent;\n  color: var(--calib-ink);\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.lt-eval-calib__top .lt-eval-calib__icon-btn {\n  border-color: var(--calib-border);\n  background: var(--calib-label-bg);\n  backdrop-filter: blur(16px) saturate(1.2);\n  -webkit-backdrop-filter: blur(16px) saturate(1.2);\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);\n}\n\n.lt-eval-calib__icon-btn:focus-visible,\n.lt-eval-calib__chip:focus-visible,\n.lt-eval-calib__lens:focus-visible,\n.lt-eval-calib__zoom-reset:focus-visible {\n  outline: 2px solid var(--calib-accent);\n  outline-offset: 2px;\n}\n\n.lt-eval-calib__zoom-pill {\n  position: absolute;\n  top: calc(58px + env(safe-area-inset-top, 0px));\n  right: calc(58px + env(safe-area-inset-right, 0px));\n  z-index: 2;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: var(--calib-label-bg);\n  border: 1px solid var(--calib-border);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  font-variant-numeric: tabular-nums;\n  color: var(--calib-ink);\n}\n\n.lt-eval-calib__rec-pill {\n  position: absolute;\n  top: calc(58px + env(safe-area-inset-top, 0px));\n  left: calc(58px + env(safe-area-inset-left, 0px));\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: rgba(127, 29, 29, 0.62);\n  border: 1px solid rgba(248, 113, 113, 0.45);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n}\n\n.lt-eval-calib__rec-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #fecaca;\n  box-shadow: 0 0 8px #ef4444;\n  animation: lt-eval-rec-pulse 1.1s ease-in-out infinite;\n}\n\n@keyframes lt-eval-rec-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.35;\n  }\n}\n\n/* Table coverage strip */\n.lt-eval-calib__tables {\n  position: absolute;\n  top: calc(52px + env(safe-area-inset-top, 0px));\n  left: calc(10px + env(safe-area-inset-left, 0px));\n  right: calc(10px + env(safe-area-inset-right, 0px));\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  pointer-events: none;\n}\n\n.lt-eval-calib__dock-row--tables {\n  max-width: 100%;\n  overflow-x: auto;\n  overscroll-behavior-x: contain;\n  scrollbar-width: none;\n  pointer-events: auto;\n  touch-action: pan-x;\n}\n\n.lt-eval-calib__dock-row--tables::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-eval-calib__tables-label {\n  flex: 0 0 auto;\n  padding: 2px 8px;\n  margin-right: 2px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: var(--calib-label-bg);\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--calib-muted);\n}\n\n.lt-eval-calib__table {\n  position: relative;\n  flex: 0 0 auto;\n  min-width: 36px;\n  padding: 0 8px;\n  font-size: 13px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.lt-eval-calib__table:not(.is-on) {\n  color: rgba(248, 250, 252, 0.62);\n  border-style: dashed;\n  border-color: rgba(255, 255, 255, 0.18);\n}\n\n.lt-eval-calib__table.is-main {\n  border-color: var(--calib-lens);\n  box-shadow: 0 0 0 1px rgba(250, 204, 21, 0.4);\n}\n\n.lt-eval-calib__table-star {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  color: var(--calib-lens);\n  fill: var(--calib-lens);\n}\n\n.lt-eval-calib__tables-all {\n  flex: 0 0 auto;\n  margin-left: 2px;\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.lt-eval-calib__tables-caption {\n  margin: 0;\n  max-width: min(92vw, 360px);\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: var(--calib-label-bg);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  font-size: 10px;\n  line-height: 1.3;\n  text-align: center;\n  color: var(--calib-muted);\n  text-shadow: none;\n}\n\n/* Portrait: side docks start below the strip */\n.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--left,\n.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--right {\n  top: calc(118px + env(safe-area-inset-top, 0px));\n}\n\n.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__zoom-pill,\n.lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__rec-pill {\n  top: calc(120px + env(safe-area-inset-top, 0px));\n}\n\n.lt-eval-calib--landscape .lt-eval-calib__tables {\n  left: calc(64px + env(safe-area-inset-left, 0px));\n  right: calc(64px + env(safe-area-inset-right, 0px));\n}\n\n.lt-eval-calib--landscape.lt-eval-calib--tables .lt-eval-calib__zoom-pill,\n.lt-eval-calib--landscape.lt-eval-calib--tables .lt-eval-calib__rec-pill {\n  top: calc(112px + env(safe-area-inset-top, 0px));\n}\n\n.lt-eval-calib--landscape .lt-eval-calib__hint {\n  left: 50%;\n  right: auto;\n  bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  max-width: min(60vw, 420px);\n}\n\n.lt-eval-calib--landscape .lt-eval-calib__edge--left {\n  top: calc(52px + env(safe-area-inset-top, 0px));\n  bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  left: calc(6px + env(safe-area-inset-left, 0px));\n}\n\n.lt-eval-calib--landscape .lt-eval-calib__edge--right {\n  top: calc(52px + env(safe-area-inset-top, 0px));\n  bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  right: calc(6px + env(safe-area-inset-right, 0px));\n}\n\n.lt-eval-calib--landscape .lt-eval-calib__chip {\n  min-width: 34px;\n  padding: 0 4px;\n}\n\n.lt-page__fab--eval {\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.lt-page__fab--eval-off {\n  background: rgba(71, 85, 105, 0.55);\n  border-color: rgba(148, 163, 184, 0.35);\n  opacity: 0.9;\n}\n\n.lt-page__fab--eval-live {\n  background: #b91c1c;\n  border-color: rgba(254, 202, 202, 0.55);\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.28),\n    0 8px 22px rgba(185, 28, 28, 0.4);\n}\n\n.lt-page__fab--eval-live .lt-eval-fab-dot {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #fecaca;\n  animation: lt-eval-rec-pulse 1.1s ease-in-out infinite;\n}\n\n@media (max-width: 420px) {\n  .lt-eval-calib {\n    --calib-tap: 38px;\n  }\n\n  .lt-eval-calib__title {\n    max-width: 36vw;\n  }\n\n  .lt-eval-calib__hint {\n    bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n    font-size: 10px;\n    max-width: min(68vw, 280px);\n  }\n\n  .lt-eval-calib__dock-row {\n    gap: 2px;\n    padding: 3px;\n  }\n}\n\n@container lt-eval-calib (max-height: 560px) {\n  .lt-eval-calib__edge--left,\n  .lt-eval-calib__edge--right {\n    top: calc(44px + env(safe-area-inset-top, 0px));\n    bottom: calc(58px + env(safe-area-inset-bottom, 0px));\n    gap: 6px;\n  }\n\n  .lt-eval-calib {\n    --calib-tap: 36px;\n  }\n\n  .lt-eval-calib__zoom-pill,\n  .lt-eval-calib__rec-pill {\n    top: calc(48px + env(safe-area-inset-top, 0px));\n  }\n\n  .lt-eval-calib__tables {\n    top: calc(44px + env(safe-area-inset-top, 0px));\n  }\n\n  .lt-eval-calib__tables-caption {\n    display: none;\n  }\n\n  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--left,\n  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--right {\n    top: calc(90px + env(safe-area-inset-top, 0px));\n  }\n\n  .lt-eval-calib--tables .lt-eval-calib__zoom-pill,\n  .lt-eval-calib--tables .lt-eval-calib__rec-pill,\n  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__zoom-pill,\n  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__rec-pill {\n    top: calc(92px + env(safe-area-inset-top, 0px));\n  }\n\n  .lt-eval-calib__hint {\n    bottom: calc(10px + env(safe-area-inset-bottom, 0px));\n  }\n}\n\n@container lt-eval-calib (max-height: 420px) {\n  .lt-eval-calib__edge--left,\n  .lt-eval-calib__edge--right {\n    top: calc(40px + env(safe-area-inset-top, 0px));\n    bottom: calc(48px + env(safe-area-inset-bottom, 0px));\n    justify-content: flex-start;\n    gap: 4px;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    scrollbar-width: none;\n  }\n\n  .lt-eval-calib__edge--left::-webkit-scrollbar,\n  .lt-eval-calib__edge--right::-webkit-scrollbar {\n    display: none;\n  }\n\n  .lt-eval-calib__hint {\n    display: none;\n  }\n\n  .lt-eval-calib__rail-label {\n    display: none;\n  }\n\n  .lt-eval-calib__tables {\n    top: calc(40px + env(safe-area-inset-top, 0px));\n  }\n\n  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--left,\n  .lt-eval-calib--tables:not(.lt-eval-calib--landscape) .lt-eval-calib__edge--right {\n    top: calc(84px + env(safe-area-inset-top, 0px));\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .lt-eval-calib__chip,\n  .lt-eval-calib__icon-btn,\n  .lt-eval-calib__lens,\n  .lt-eval-calib__preview,\n  .lt-eval-calib__rec-dot,\n  .lt-page__fab--eval-live .lt-eval-fab-dot {\n    transition: none;\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
